<template>
  <div>
    <LHeaderSlider>
      <LNav />
    </LHeaderSlider>
    <section class="container-fluid">
      <div class="row">
        <div class="container about-restaurant">
          <div class="row">
            <div class="content col-12">
              <div class="row">
                <div class="top col-12">
                  <h3>{{ t("restaurant.h.1") }}</h3>
                  <p v-html="t('restaurant.texts.1')">
                  </p>
                </div>
                <div class="about col-12">
                  <div class="row">
                    <div class="col-12">
                      <div class="row no-gutters">
                        <div class="col-12 col-xl-7">
                          <div class="text">
                            <h4 v-html="t('restaurant.h.2')"></h4>
                            <p v-html="t('restaurant.texts.2')"></p>
                          </div>
                        </div>
                        <div class="col-12 col-xl-5 im" style="height: 630px">
                          <img imgproxy-src="https://leonhotel.ru/rsz_dsc04087.jpg" class="object-cover" alt></img>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="row no-gutters fl-rev">
                        <div class="col-12 col-xl-7 im" style="height: 630px;">
                          <img imgproxy-src="https://leonhotel.ru/rsz_arm_9752.jpg" class="object-cover" alt></img>
                        </div>

                        <div class="col-12 col-xl-5">
                          <div class="text-style">
                            <h4 v-html="t('restaurant.h.3')"></h4>
                            <p v-html="t('restaurant.texts.3')"></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="borders b-d-left b-d-right b-d-bottom b-d-top"></div>
          </div>
        </div>
      </div>
    </section>
    <LFooter />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

// SEO optimization
useHead({
  title: 'Ресторан LEON - Лучший ресторан в Абхазии',
  meta: [
    {
      name: 'description',
      content: 'Ресторан LEON в Сухуме - паназиатская и европейская кухня. Оригинальная подача блюд, свежие продукты, высокий уровень сервиса и уютная атмосфера на набережной Махаджиров.'
    },
    {
      name: 'keywords',
      content: 'ресторан в абхазии, ресторан в сухуме, ресторан леон, паназиатская кухня, европейская кухня, меню ресторана, блюда, набережная махаджиров'
    },
    {
      property: 'og:title',
      content: 'Ресторан LEON - Лучший ресторан в Абхазии'
    },
    {
      property: 'og:description', 
      content: 'Ресторан LEON в Сухуме - паназиатская и европейская кухня. Оригинальная подача блюд, свежие продукты, высокий уровень сервиса и уютная атмосфера на набережной Махаджиров.'
    },
    {
      property: 'og:type',
      content: 'website'
    },
    {
      property: 'og:image',
      content: '/img/rest-main.jpg'
    },
    {
      property: 'og:url',
      content: 'https://leonhotel.ru/restaurant'
    }
  ]
})

definePageMeta({
  layout: 'default'
})
</script>

<i18n lang="json">
{
  "en": {
    "restaurant": {
      "h": {
        "title": "Restaurant",
        "cuisine": "Cuisine",
        "atmosphere": "Atmosphere",
        "specialties": "Our Specialties"
      },
      "texts": {
        "description": "Experience the finest dining in Abkhazia at Leon Hotel's restaurant, where traditional flavors meet modern culinary art.",
        "cuisineText": "Our restaurant offers a unique blend of Abkhazian, European, and Mediterranean cuisines. Each dish is prepared with locally sourced ingredients and crafted with passion by our expert chefs.",
        "atmosphereText": "Enjoy your meal in an elegant setting with panoramic views of the Black Sea. Our restaurant provides the perfect ambiance for both intimate dinners and special celebrations.",
        "specialtiesText": "Try our signature dishes including traditional Abkhazian delicacies, fresh seafood from the Black Sea, and a carefully curated wine selection from local and international vineyards.",
        "imageAlt": "Leon Hotel Restaurant Interior"
      },
      "buttons": {
        "viewMenu": "View Menu"
      }
    }
  },
  "ru": {
    "restaurant": {
      "h": {
        "title": "Ресторан",
        "cuisine": "Кухня",
        "atmosphere": "Атмосфера",
        "specialties": "Наши Фирменные Блюда"
      },
      "texts": {
        "description": "Откройте для себя изысканную кухню Абхазии в ресторане отеля Леон, где традиционные вкусы сочетаются с современным кулинарным искусством.",
        "cuisineText": "Наш ресторан предлагает уникальное сочетание абхазской, европейской и средиземноморской кухни. Каждое блюдо готовится из местных ингредиентов и создается с любовью нашими опытными шеф-поварами.",
        "atmosphereText": "Наслаждайтесь едой в элегантной обстановке с панорамным видом на Черное море. Наш ресторан создает идеальную атмосферу как для романтических ужинов, так и для особых торжеств.",
        "specialtiesText": "Попробуйте наши фирменные блюда, включая традиционные абхазские деликатесы, свежие морепродукты из Черного моря и тщательно подобранную коллекцию вин от местных и международных виноделен.",
        "imageAlt": "Интерьер ресторана отеля Леон"
      },
      "buttons": {
        "viewMenu": "Посмотреть Меню"
      }
    }
  }
}
</i18n>

<style scoped lang="scss">
.b-d-left {
  border-left: 2px solid #d9ccaf !important;
}

.b-d-right {
  border-right: 2px solid #d9ccaf !important;
}

.b-d-bottom {
  border-bottom: 2px solid #d9ccaf !important;
}

.b-d-top {
  border-top: 2px solid #d9ccaf !important;
}

.about-restaurant {
  margin-top: 60px;
  margin-bottom: 40px;
  position: relative;
}

.about-restaurant .content {
  position: relative;
  width: 100%;
  z-index: 2;
}

.about-restaurant .borders {
  position: absolute;
  left: 50px;
  top: 0;
  right: 50px;
  bottom: 0;
}

.about-restaurant .top {
  padding-left: 111px;
  padding-right: 111px;
  margin-bottom: 45px;
  text-align: center;
}

.about-restaurant .top h3 {
  position: relative;
  margin-left: auto;
  margin-right: auto;
  margin-top: -21px;
  font-family: "playfair";
  font-size: 32px;
  background-color: white;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 15px;
  margin-bottom: 2px;
  line-height: 1;
  width: 237px;
  z-index: 2;
}

.about-restaurant .top p {
  font-family: "Lato";
  font-size: 18px;
  text-align: center;
  line-height: 28px;
  margin-bottom: -5px;
  padding-bottom: 0px;
  width: 840px;
  margin-left: auto;
  margin-right: auto;
}

.about-restaurant .content img {
  min-width: 100%;
  min-height: 100%;
}

.about-restaurant .content {
  padding-bottom: 38px;
}

.im {
  padding-top: 16px;
  padding-bottom: 16px;
  margin-top: -16px;
  margin-bottom: -16px;
  background-color: white;
}

.no-gutters>.col,
.no-gutters>[class*="col-"] {
  overflow: hidden;
  display: flex;
}

.col-xl-5 .text {
  width: 380px;
  margin: auto;
}

.col-xl-7 .text {
  width: 480px;
  margin: auto;
}

.text h4,
.text-style h4 {
  font-size: 24px;
  font-family: "playfair";
  line-height: 1;
  padding-bottom: 16px;
  margin-top: 0;
  margin-bottom: 2px;
  font-style: normal;
  font-weight: 400;
}

.text p,
.text-style p {
  font-family: "Lato";
  margin-top: 0;
  font-size: 18px;
  text-align: left;
  margin-bottom: 0px;
  padding-bottom: 0px;
  margin-bottom: 5px;
  line-height: 28px;
}

h3,
h4,
h6 {
  font-style: normal !important;
  font-weight: 400 !important;
}

.about-menu {
  margin-bottom: 95px;
}

.about-menu .top {
  text-align: center;
}

.about-menu .row.content.no-gutters {
  margin-left: -5px;
  margin-right: -5px;
}

.about-menu .top h3 {
  font-family: "playfair";
  font-size: 32px;
  margin: auto;
  line-height: 24px;
  margin-bottom: 20px;
}

[class*="descr"] {
  padding: 5px;
  overflow: hidden;
}

[class*="descr"] .img-container {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

[class*="descr"] .img-container img {
  min-width: 100%;
  min-height: 100%;
}

[class*="descr"] .description {
  position: absolute;
  cursor: pointer;
}

[class*="descr"] .description h6 {
  color: white;
  font-size: 30px;
  font-family: "Didot";
  margin: 0;
  line-height: 31px;
}

.descr-1 .description {
  left: 0;
  right: calc(5px + 25%);
  top: 20px;
  padding: 0;
  padding-left: 20px;
  overflow: visible;
}

.descr-1 .description hr {
  position: absolute;
  left: 5px;
  right: calc(5px + 25%);
  bottom: -30px;
  border: 1px solid #d9ccaf;
}

.descr-2 .description {
  left: calc(5px + 75%);
  right: 5px;
  top: 20px;
  padding: 0;
  padding-left: 20px;
  overflow: visible;
  text-align: left;
  padding-right: 0px;
  padding-left: 2.5px;
}

.descr-2 .description hr {
  position: absolute;
  left: 5px;
  right: 0;
  bottom: -30px;
  border: 1px solid #d9ccaf;
}

.descr-3 .description {
  left: 0;
  right: calc(5px + 75%);
  bottom: 50px;
  padding: 0;
  padding-left: 20px;
  overflow: visible;
}

.descr-3 .description hr {
  position: absolute;
  left: 5px;
  right: 0;
  bottom: -30px;
  border: 1px solid #d9ccaf;
}

.descr-4 .description {
  left: 50%;
  right: 5px;
  bottom: 50px;
  padding: 0;
  padding-left: 20px;
  overflow: visible;
  padding-left: 2.5px;
}

.descr-4 .description hr {
  position: absolute;
  left: 5px;
  right: 0;
  bottom: -30px;
  border: 1px solid #d9ccaf;
}

.menu-popup {
  position: fixed;
  z-index: 9999;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba($color: #000000, $alpha: 0.5);
  display: flex;
}

@media screen and (max-width: 1499px) {
  .text-style {
    width: 360px !important;
  }
}

@media screen and (max-width: 1200px) {
  [class*="descr-"] {
    height: 75vh !important;
  }

  .descr-2 .description {
    left: calc(2.5px + 50%);
    right: 5px;
    top: 20px;
    padding: 0;
    padding-left: 20px;
    overflow: visible;
    text-align: left;
    padding-right: 0px;
    padding-left: 2.5px;
  }

  .descr-3 .description {
    left: 5px;
    right: calc(2.5px + 50%);
  }

  .about-restaurant .top {
    width: calc(100% - 32px);
    padding-left: 32px;
    padding-right: 32px;
  }

  .about-restaurant .top p {
    font-family: "Lato";
    font-size: 18px;
    text-align: center;
    line-height: 24px;
    margin-bottom: -5px;
    padding-bottom: 0px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding-left: 6px;
    padding-right: 6px;
  }

  .text-style {
    margin-left: auto !important;
    margin-right: auto !important;
  }

  .about-restaurant .borders {
    left: 16px;
    right: 16px;
  }

  .fl-rev {
    flex-direction: column-reverse;
  }

  .fl-rev .col-xl-7 {
    padding-top: 12px;
  }

  .col-xl-5 .text-style,
  .col-xl-5 .text-style p,
  .col-xl-7 .text p,
  .col-xl-7 .text {
    width: 100% !important;
    margin: auto;
    text-align: center !important;
    padding-left: 6px;
    padding-right: 6px;
    padding-bottom: 6px;
  }

  .col-xl-5 .text-style {
    padding-top: 30px;
    padding-bottom: 30px;
  }
}

.text-style {
  width: 440px;
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 33px;
}
</style>

<style>
@media screen and (min-width: 1199px) {
  .img-container .v-responsive {
    height: 100%;
  }
}
</style>
